import PromotionBridge from '@messenger/components/PromotionBridge';
import MessengerPageLayout from '@messenger/pages/MessengerPageLayout';

import { composeServerSideProps } from '~utils/composeServerSideProps';
import { checkMobileServerSideProps } from '~serverSideProps/checkMobile';
import { webViewServerSideProps } from '~serverSideProps/webView';

export const getServerSideProps = composeServerSideProps([
  checkMobileServerSideProps,
  webViewServerSideProps,
]);

export default function MessengerPromotionBridgePage() {
  return (
    <MessengerPageLayout>
      <PromotionBridge />
    </MessengerPageLayout>
  );
}
